import React from 'react';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';

// Magic strings
const ShowPassword = "Show Password";
const HidePassword = "Hide Password";
const text = "text";
const password = "password";
const span = "SPAN";

//nothing specific to handle in generic component as of now. Need to handle if anything.
export default class GenericInput extends React.Component {

    constructor(props) {
        super(props);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.onEyeClick = this.onEyeClick.bind(this);
        this.togglePasswordField = this.togglePasswordField.bind(this);

        this.state = {
            tooltipOpen: false,
            invalidInput: false,
            value: this.props.value
        };
        this.genericInputEl = React.createRef();
        this.parentOfInput = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    onChange(event) {
        const { onChange, required } = this.props;
        const value = event.target.value;
        if (onChange) {
            onChange(event, value, required && value.trim() !== '');
        }
        this.setState({ value: value });
    }

    togglePasswordField(e) {
        //if (e.relatedTarget) return;
        if (this._isMounted) {
            const input = this.genericInputEl.current;
            input.type = password;
            const passwordEyeSpan = this.parentOfInput.current.querySelector("span.password-eye");
            this.togglePasswordEye(passwordEyeSpan, input.type);
            if (!passwordEyeSpan) return;
            passwordEyeSpan.classList.remove("icon-eye");
        }
    }

    isValid(value) {
        const { pattern } = this.props;
        return Boolean(value) || value.trim() && (typeof pattern === 'undefined' || pattern.test(value));
    }

    validateOnBlur(event) {
        const value = event.target.value;
        const isValid = this.isValid(value);
        if (this.props.onChange) {
            this.props.onChange(event, value, isValid);
        }
        if (this.props.required || this.props.pattern) {
            event.persist();
            this.setState({ invalidInput: !isValid });
        }
    }

    clearInput(event) {
        if (this._isMounted) {
            this.genericInputEl.current.value = "";
            var e = { event, target: { value: "", name: this.props.name ? this.props.name : ""} };

            this.onChange(e);
        }
    }

    togglePasswordEye(span, inputType) {
        if (!span) return;
        const { type, showEye } = this.props;
        if (type !== password && !showEye) return;
        if (inputType === password) {
            span.title = ShowPassword;
            span.parentElement.classList.remove("active");
            span.classList.add("icon-eye");
        }
        else {
            span.title = HidePassword;
            span.parentElement.classList.add("active");
            span.classList.add("icon-eye");
        }
    }

    onEyeClick(e) {
        const { type } = this.props;
        if (type !== password) return;
        if (this._isMounted) {
            const input = this.genericInputEl.current;
            if (input.type === password) {
                input.type = text;
            } else {
                input.type = password;
            }
            input.focus();
            if (e.target)
                this.togglePasswordEye(e.target, input.type);
        }
    }

    onFocus(e) {
        const { type, showEye, value } = this.props;
        const thisValue = value || this.state.value || "";
        if (type === password && showEye && thisValue) {
            const passwordEyeSpan = this.parentOfInput.current.querySelector("span.password-eye");
            if (!passwordEyeSpan) return;
            passwordEyeSpan.classList.add("icon-eye");
        }
    }

    onKeyUp = e => {
        if (!this.props.pattern) {
            this.validateOnBlur(e);
            if (this.props.onKeyUp) {
                this.props.onKeyUp(e);
            }
        }
    }

    onKeyDown = e => {
        if (!this.props.pattern || e.altKey || e.ctrlKey) {
            return;
        }
        else if (!this.props.pattern.test(e.key)) {
            e.preventDefault();
            return;
        }

        this.validateOnBlur(e);
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
        }
    }

    onKeyPress = e => {
        if (this.props.onKeyPress) {
            this.props.onKeyPress(e);
        }
    }

    onPaste = event => {
        if (this.props.pattern) {
            const data = window.clipboardData ? window.clipboardData.getData('text') : event.clipboardData.getData('text/plain');
            const target = event.target;
            const start = target.selectionStart;
            const end = target.selectionEnd;
            const value = target.value;
            const maxLength = this.props.maxLength ? Math.min(this.props.maxLength - value.length + end - start, data.length) : data.length;
            let filteredData = '';
            for (let i = 0, count = 0; i < data.length && count < maxLength; i++) {
                if (this.props.pattern.test(data[i])) {
                    filteredData += data[i];
                    count++;
                }
            }
            target.value = value.substr(0, start) + filteredData + value.substr(end);
            target.selectionStart = target.selectionEnd = start + filteredData.length;
            event.preventDefault();
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
            const event2 = document.createEvent('Event'); //new Event('input', { bubbles: true });
            event2.initEvent('init', true, true);
            nativeInputValueSetter.call(target, target.value);
            target.dispatchEvent(event2);
            if (this.props.onChange) {
                const isValid = this.isValid(target.value);
                this.props.onChange(event, isValid);
            }
        }
    }

    render() {
        const {
            placeholder,
            value,
            required,
            name,
            id,
            autoFocus,
            onBlur,
            disabled,
            maxLength,
            inputErrorMsg,
            tooltipID,
            tooltipMsg,
            type,
            className,
            autoComplete,
            showAsInvalid,
            onFocus,
            inputBtnClick,
            inputBtnIcon,
            inputBtnLabel,
            showClearBtn,
            showEye,
            isFieldEmpty
        } = this.props;
        const thisValue = isFieldEmpty ? "" : value || this.state.value || ""; // in case the value property is being applied externally
        const containerClassName =
            (thisValue ? " input-not-empty" : "") + (className ? " " + className + " " : " ") +
            (this.state.invalidInput || showAsInvalid ? " input-invalid" : "") +
            ((tooltipID && tooltipMsg) ? " input-append" : "") + (showClearBtn ? " input-clear-btn" : "") + (showEye && thisValue && type === password ? " input-password-btn" : "");

        return (<div className={"il-group" + containerClassName} ref={this.parentOfInput} onBlur={type === password && showEye ? this.togglePasswordField : undefined}>
            <input type={type ? type : "text"}
                className="form-control"
                value={thisValue}
                required={required}
                name={name}
                id={id}
                disabled={disabled}
                autoFocus={autoFocus}
                placeholder={placeholder ? placeholder : ""}
                maxLength={maxLength ? maxLength : ""}
                onChange={e => this.onChange(e)}
                onBlur={onBlur ? onBlur : this.validateOnBlur}
                onKeyUp={this.onKeyUp}
                onKeyDown={this.onKeyDown}
                onKeyPress={this.onKeyPress}
                autoComplete={autoComplete}
                onPaste={this.onPaste}
                onFocus={(e) => {
                    this.onFocus(e);
                    if (onFocus) onFocus(e);
                }}
                aria-label={placeholder ? placeholder : ""}
                title={placeholder ? "Please fill out the " + placeholder : "Please fill out this field."}
                ref={this.genericInputEl}
            />

            {(tooltipID && tooltipMsg) && <div className="input-icon-append ">
                <span className="icon-info" id={tooltipID} />
                <Tooltip placement="top" isOpen={this.state.tooltipOpen} autohide={false} target={tooltipID} toggle={this.toggleTooltip}>
                    {tooltipMsg}
                </Tooltip>
            </div>}
            {(inputBtnClick && inputBtnIcon) &&
                <div className="input-icon-append">
                    <button type="button" onClick={e => inputBtnClick(e)} aria-label={inputBtnLabel ? inputBtnLabel : ""}><span className={inputBtnIcon} /></button>
                </div>
            }
            {showClearBtn && thisValue && <span className="clear-btn" aria-label="clear button" onClick={e => this.clearInput(e)}><span className="icon-input-clear" /></span>}
            {thisValue && showEye && type === password && <div className="password-icon-append">
                <span className="icon-eye password-eye" title={ShowPassword} onClick={this.onEyeClick} onMouseDown={(e) => { e.preventDefault(); }} />
            </div>}
            <div className="il-label" aria-hidden="true">{placeholder}</div>
            {inputErrorMsg && <div className="input-error-msg">{inputErrorMsg}</div>}
        </div>
        );
    }
}

GenericInput.propTypes = {
    className: PropTypes.string
}